import {push} from '@raison/navigation';
import {CardId, Maybe} from '@raison/types';
import {Action} from 'redux';
import {groupOperationsByType, selectFinancesData} from '~/redux/finances/financesPrimitives';
import {FinancialData} from '~/redux/finances/financesReducer';
import {createOperationRoute} from '~/redux/finances/financesRouting';
import {updatePaymentMethod} from '~/redux/payments/paymentActions';

export const getTopupCardAction = (cardId: CardId, financialData: FinancialData | undefined) => {
    return Maybe.from(financialData)
        .andThen(finances =>
            groupOperationsByType(finances).topup.find(
                op => op.target.type === 'card' && op.target.id === cardId && op.account.currencyCode === 'EUR'
            )
        )
        .andThen(operation => operation.account)
        .andThen(eurAccount => [
            updatePaymentMethod({type: 'card', id: cardId, actionType: 'topup', currency: 'eur'}),
            push(createOperationRoute('topup', eurAccount, {id: cardId, type: 'card'})),
        ])
        .fallbackTo<Action[]>([]).value;
};

export const selectCardsDisabledFlag = (store: AppModel) =>
    !!selectFinancesData(store)?.operationsSettings.cards_disabled;
